import {
  PropsalData,
  ValidateForm,
  ValidateFormModal
} from "../../pages/new-order/types/bigForm";
import { http } from "../infrastructure/Https";
import tokenService from "../services/TokenService";
import { SendNewOrderResponse } from "../types/bigForm";
import {
  AllLeadsData,
  BodyParamsGetLeads,
  LeadDocPackType,
  LeadDocType,
  leadFullInfo,
  leadStatusType,
  leadsListType,
} from "../types/leadsApiTypes";
import { individualIpotekaType } from "../types/productTypes";
const ROOT_URL = "/api/v1/lead";


class LeadsApi {
  //---------------documents new-----------

  //GET /api/v1/leads/{id}/documents/multi Получение пакетов документов заявки
  getLeadDocPacks(leadId: number): Promise<LeadDocPackType[]> {
    const accessToken = tokenService.getAccessToken();
    return http.get(`${ROOT_URL}s/${leadId}/documents/multi`, null, accessToken);
  }

  //POST /api/v1/leads/pack/documents загрузка файлов (несколько или 1) с EDS или без в заявку
  uploadDoc(packId: number, formData: FormData): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.post(
      `${ROOT_URL}s/pack/documents`,
      null,
      formData,
      accessToken
    );
  }
  //POST /api/v1/leads/pack/documents with progress bar. загрузка файлов (несколько или 1) с EDS или без в заявку
  uploadFile(
    packId: number,
    formData: FormData,
    onProgress: (percentage: number, loadedMB: string, totalMB: string) => void,
    signal: AbortSignal
  ) {
    return new Promise((resolve, reject) => {
      const url = `${ROOT_URL}s/pack/documents`
      const xhr = new XMLHttpRequest();
      const accessToken = tokenService.getAccessToken();
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`);
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percentage = (event.loaded / event.total) * 100;
          const loadedMB = (event.loaded / 1024 / 1024).toFixed(2);
          const totalMB = (event.total / 1024 / 1024).toFixed(2);
          onProgress(percentage, loadedMB, totalMB);
        }
      };
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(JSON.parse(xhr.responseText));
        } else {
          reject(`Upload failed: ${xhr.status} ${xhr.statusText}`);
        }
      };
      xhr.onerror = () => {
        reject('Network error occurred during the upload process');
      };
      // listen for the abort event
      signal.addEventListener('abort', () => {
        xhr.abort();
        reject(new Error('прервано'));
      });
      xhr.send(formData);
    });
  };

  //PUT /api/v1/leads/packdocuments/{DocumentPackId}/signature прикрепить открепленную ЭЦП
  attachDocEds(
    packId: number,
    formData: FormData
  ): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.put(
      `${ROOT_URL}s/packdocuments/${packId}/signature`,
      null,
      formData,
      accessToken
    );
  }

  //DELETE ​/api​/v1​/leads​/packdocuments/{LeadDocumentId} Удалить документ из заявки by doc id
  deleteDoc(docId: number): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.delete(
      `${ROOT_URL}s/packdocuments/${docId}`,
      null,
      null,
      accessToken
    );
  }

  //GET ​/api​/v1​/leads​/leaddocuments/{id} Получение документа by id
  //параметр partner_example - если true то скачается пример документа от партнера - no need
  getDocFile(
    docId: number,
    Q?: { partner_example: boolean }
  ): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.getWithBlob(
      `${ROOT_URL}s/leaddocuments/${docId}`,
      Q,
      accessToken
    );
  }

  //POST /api/v1/leads/{LeadId}/documents/sendV2 отправить загруженные документы
  sendDocPacks(
    leadId: string,
    data: { leadId: number; documents: number[] }
  ): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.post(
      `${ROOT_URL}s/${leadId}/documents/sendV2`,
      null,
      data,
      accessToken
    );
  }

  ///old docs. TODO: remove than partner lead page is ready

  //DELETE ​/api​/v1​/leads​/{leadid}​/documents​/{documentid} Удалить документ из заявки
  deleteLeadDoc(leadId: number, documentId: number): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.delete(
      `${ROOT_URL}s/${leadId}/documents/${documentId}`,
      null,
      null,
      accessToken
    );
  }
  //PUT ​/api​/v1​/leads​/{leadid}​/documents​/{documentid} Заменить файл документа заявки
  replaceLeadDoc(
    leadId: number,
    documentId: number,
    document: any,
    IsAttachedSignature: boolean
  ): Promise<any> {
    const formData = new FormData();
    formData.append("document", document);
    formData.append("IsAttachedSignature", IsAttachedSignature.toString());

    const accessToken = tokenService.getAccessToken();
    return http.put(
      `${ROOT_URL}s/${leadId.toString()}/documents/${documentId.toString()}`,
      null,
      formData,
      accessToken
    );
  }

  //GET ​/api​/v1​/leads​/documents​/{id} Получение документа
  //параметр partner_example - если true то скачается пример документа от партнера
  getLeadDoc(
    documentId: number,
    Q?: { partner_example: boolean }
  ): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.getWithBlob(
      `${ROOT_URL}s/documents/${documentId}`,
      Q,
      accessToken
    );
  }

  getLeadDocAct(
    documentId: number,
    Q?: { partner_example: boolean }
  ): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.getWithBlob(`/api/v1/agent/act/${documentId}`, Q, accessToken);
  }

  // GET ​/api​/v1​/leads​/{leadid}​/documents​/send Состояние загрузки документов по запросам
  getLeadDocsSendStatus(leadId: number): Promise<{ sendDocsState: string }> {
    const accessToken = tokenService.getAccessToken();
    return http.get(`${ROOT_URL}s/${leadId}/documents/send`, null, accessToken);
  }

  //GET ​/api​/v1​/leads​/{id}​/documents Получение документов заявки
  getLeadDocs(leadId: number): Promise<LeadDocType[]> {
    const accessToken = tokenService.getAccessToken();
    return http.get(`${ROOT_URL}s/${leadId}/documents`, null, accessToken);
  }

  // POST  ​/api​/v1​/leads​/{id}​/documents    Приложить документ к заявке
  sendDocToBank(leadId: number, docType: number, document: any): Promise<any> {
    const formData = new FormData();
    formData.append("Document.DocumentType", docType.toString());
    formData.append("Document.Document", document);
    const accessToken = tokenService.getAccessToken();
    return http.post(
      `${ROOT_URL}s/${leadId}/documents`,
      null,
      formData,
      accessToken
    );
  }
  //TODO: remove with all unused components
  sendIpotekaApplication(
    Q: individualIpotekaType | any,
    alias: string
  ): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.post(
      `${ROOT_URL}/createAnonymousLead/${alias}`,
      null,
      Q,
      accessToken
    );
  }
  //PUT ​/api​/v1​/leads​/{leadid}​/documents​/{documentid}​/signature Прикрепить/заменить открепленную эцп заявителя у документа
  attachDocSignature(
    leadId: number,
    documentid: number,
    document: any
  ): Promise<any> {
    const formData = new FormData();
    formData.append("DocumentSignature", document);
    const accessToken = tokenService.getAccessToken();
    return http.put(
      `${ROOT_URL}s/${leadId}/documents/${documentid}/signature`,
      null,
      formData,
      accessToken
    );
  }
  //POST ​/api​/v1​/leads​/{leadid}​/documents​/send Разрешить отправку последних приложенных документов заявки в банк
  sendDocsToBank(leadid: string): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.post(
      `${ROOT_URL}s/${leadid}/documents/send`,
      null,
      null,
      accessToken
    );
  }

  //GET ​/api​/v1​/leads​/documents​/{id}​/signature​/{sid} Получение подписи Документа
  getDocSign(id: number, sid: number): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.get(
      `${ROOT_URL}s/documents/${id}/signature/${sid}`,
      null,
      accessToken
    );
  }

  //---------------заявки-----------
  //DELETE ​/api​/v1​/lead​/{leadId} Отзыв заявки по идентификатору.
  deleteLeadById(leadId: string): Promise<leadFullInfo> {
    const accessToken = tokenService.getAccessToken();
    return http.delete(`${ROOT_URL}/${leadId}`, null, null, accessToken);
  }

  //GET ​/api​/v1​/lead​/{leadId} Получение заявки по идентификатору.
  getLeadById(leadId: string): Promise<leadFullInfo> {
    const accessToken = tokenService.getAccessToken();
    return http.get(`${ROOT_URL}/${leadId}`, null, accessToken);
  }

  getDeleteInfoById(leadId: string): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.get(`${ROOT_URL}/${leadId}/delete_state`, null, accessToken);
  }

  //POST ​/api​/v1​/leadsv2 Получение всех заявок
  getAllLeads(
    B: BodyParamsGetLeads
  ): Promise<AllLeadsData> {
    const accessToken = tokenService.getAccessToken();
    return http.post
      (`${ROOT_URL}sv2`,
        null,
        B,
        accessToken)
  }


  //GET ​/api​/v1​/leads​/{productId} Получение списка заявок по продуктам
  getLeadsListByProductId(
    productId: string,
    archive?: boolean
  ): Promise<leadsListType> {
    const params = new URLSearchParams();
    if (archive) {
      params.append("isarchive", `true`);
    } else {
      params.append("isarchive", `false`);
    }
    const accessToken = tokenService.getAccessToken();
    return http.getWithParams(
      `${ROOT_URL}s/${productId}`,
      params,
      null,
      accessToken
    );
  }

  // GET ​/api​/v1​/lead​/status​/{leadId} Получение статуса заявки по идентификатору.
  getLeadStatusById(leadId: number): Promise<leadStatusType> {
    const accessToken = tokenService.getAccessToken();
    return http.get(`${ROOT_URL}/status/${leadId}`, null, accessToken);
  }

  getPartnerStatuses(): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.get(`/api/v1/reference/partnerstatus`, null, accessToken);
  }

  //---------------созадние/валидирование заявки-----------
  //GET ​/api​/v1​/leads​/fields Получение списка полей для заполнения заявки.
  getLeadsFields(Q: URLSearchParams | undefined) {
    const accessToken = tokenService.getAccessToken();
    return http.getWithParams(`${ROOT_URL}s/fields`, Q, null, accessToken);
  }
  //GET ​/api​/v1​/leads​/fieldsv3 Получение списка полей для заполнения заявки для большой формы.
  getLeadsBigFields(Q: URLSearchParams | undefined) {
    const accessToken = tokenService.getAccessToken();
    return http.getWithParams<null, PropsalData[]>(
      // `${ROOT_URL}s/fieldsv4`,
      `${ROOT_URL}s/getfieldsV5`,
      // `${ROOT_URL}s/getfieldsV6`,
      Q,
      null,
      accessToken
    );
  }

  //POST ​/api​/v1​/leads Создание новых заявок
  sendNewOrder<B>(body: B) {
    // console.log("****sendNewOrder");
    const accessToken = tokenService.getAccessToken();
    return http.post<null, B, SendNewOrderResponse>(
      `${ROOT_URL}sv3`,
      null,
      body,
      accessToken
    );
  }

  // PUT​/api​/v1​/leadsv2  Редактирование заявки
  saveDraft<B>(body: B) {
    // console.log("****saveDraft");
    const accessToken = tokenService.getAccessToken();
    return http.put<null, B, SendNewOrderResponse>(
      `${ROOT_URL}sv3`,
      null,
      body,
      accessToken
    );
  }

  //POST /api/v1/leads/validate Валидация заявки
  sendDataForValidate<R>(body: ValidateForm | ValidateFormModal) {
    const accessToken = tokenService.getAccessToken();
    return http.post<null, ValidateForm | ValidateFormModal, R>(
      `${ROOT_URL}s/validatev4`,
      null,
      body,
      accessToken
    );
  }

  sendDataForValidateV5<R>(body: ValidateForm | ValidateFormModal) {
    const accessToken = tokenService.getAccessToken();
    return http.post<null, ValidateForm | ValidateFormModal, R>(
      `${ROOT_URL}s/validatev5`,
      null,
      body,
      accessToken
    );
  }

  //Запросы по ссылкам из филдов формы
  sendRequestFromField<R>(url: string) {
    const accessToken = tokenService.getAccessToken();
    return http.get<any, R>(url, undefined, accessToken);
  }

  //PUT ​/api​/v1​/leads​/{leadid}​/archive Архивирование заявки
  putLeadArchive(leadid: string) {
    const accessToken = tokenService.getAccessToken();
    return http.putWithParams(
      `${ROOT_URL}s/${leadid}/archive`,
      undefined,
      accessToken
    );
  }
}

const leadsApi = new LeadsApi();
export default leadsApi;
